import React, { useMemo } from 'react';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import {
  convertToDayJs,
  getCurrentTimeDiff,
  getDayOfWeek,
  isNil,
  isNotNil,
} from 'shared/src/utils';
import { Colors, ColorValues, Flex, Typography } from '@banhala/ui-kit';
import { useRemainTimeTextFormat } from '../../../hooks/useRemainTimeTextFormat';
import { useGetDeliveryOrderDeadlineTime } from '../../../hooks/useGetDeliveryOrderDeadlineTime';
import { useGetNextWorkingDay } from 'shared/src/hooks';
import { useGoodsDetail } from '../../../queries/useGoodsDetail';

export const RemainTimer: React.FC<{ formatStr?: string }> = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const { data: goodsDetail } = useGoodsDetail();

  const limitTime = useGetDeliveryOrderDeadlineTime(goodsBasic);

  const { isTimeOver, text, isOneHourRemaining } = useRemainTimeTextFormat(
    limitTime?.format('YYYY-MM-DD HH:mm:ss') ?? null,
  );

  const nextDepartureDay = useGetNextWorkingDay(
    isNotNil(limitTime) ? convertToDayJs(limitTime) : null,
  );

  const isNextDayIsTomorrow = useMemo(() => {
    if (isNotNil(nextDepartureDay)) {
      return getCurrentTimeDiff(nextDepartureDay, 'days') === 0;
    }
    return false;
  }, [nextDepartureDay]);

  const arrivalDay = useGetNextWorkingDay(
    goodsDetail?.goods.market.estimated_delivery_days && nextDepartureDay
      ? nextDepartureDay?.add(goodsDetail?.goods.market.estimated_delivery_days)
      : null,
  );

  if (isNil(limitTime)) return null;

  if (isNil(nextDepartureDay)) return null;

  if (!isTimeOver) {
    return (
      <Typography type={'body2'}>
        <Typography
          type={'subtitle2'}
          rawColor={
            isOneHourRemaining
              ? Colors.content_pink_primary
              : ColorValues.lilac40
          }
        >
          {text}
        </Typography>{' '}
        내 주문하면{' '}
        <Typography type={'subtitle2'}>
          오늘 {limitTime.format('M/D')}({getDayOfWeek(limitTime)})
        </Typography>{' '}
        출발 예정
      </Typography>
    );
  }

  if (isNotNil(arrivalDay)) {
    return (
      <Flex gap={8}>
        <Typography type={'body2'}>
          주문 마감으로{' '}
          <Typography type={'subtitle2'}>
            {isNextDayIsTomorrow ? '내일 ' : ''}
            {nextDepartureDay.format('M/D')}({getDayOfWeek(nextDepartureDay)})
          </Typography>{' '}
          출발 예정
        </Typography>
      </Flex>
    );
  }

  return (
    <Typography type={'body2'}>
      주문 마감으로{' '}
      <Typography type={'subtitle2'}>
        {isNextDayIsTomorrow ? '내일 ' : ''}
        {nextDepartureDay.format('M/D')}({getDayOfWeek(nextDepartureDay)})
      </Typography>{' '}
      출발 예정
    </Typography>
  );
};
